import { MerchandisingRuleWithExtraIndications } from '../../MerchandisingRules/components/MerchandisingRulesListPage/components';

export const isRuleInvalid = (rule: MerchandisingRuleWithExtraIndications): boolean => {
  return rule.isInvalidEmptyRegions || !rule.hasOnlyValidRegions || rule.isUsingInvalidDataField;
};
